import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/api';

export const fetchAuditLogs = createAsyncThunk(
  'audit/fetchAll',
  async (params, { rejectWithValue }) => {
    try {
      const res = await apiService.getAuditLogs(params || {});
      // Handle both { data: [...] } and direct [...] response formats
      return Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
    } catch (err) {
      return rejectWithValue(err.body?.error || err.message);
    }
  }
);

const auditSlice = createSlice({
  name: 'audit',
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuditLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAuditLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchAuditLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default auditSlice.reducer;
